
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { routerNames } from "@/common/js/const";
import { setToken, getToken } from "@/common/js/common.js";
import Box from 'vux/src/components/box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import conf from "./../../config/base.js";

export default {
name: routerNames.OrderInvoiceFollow,
components: {
Box,
Group,
Cell,
CellBox,
XHeader
},
data() {
return {
qrSrc: '',
logoSrc: '',
code: '',
state: '',
merchant: '',
cpy: '',
token: '',
isShowQR: false,
qrMsg: '',
};
},
created() {},
activated() {
var $self = this;
var queryStr = $self.getRequest();
$self.code = queryStr.code;
var state = queryStr.state;
if (state != undefined && state.indexOf('_') > -1) {
var arr = state.split('_');
if (arr.length == 3) {
$self.state = arr[0];
$self.merchant = arr[1];
$self.cpy = arr[2];
}
}
$self.logoSrc = '/xforce/static/merch/' + $self.merchant + '/logo.jpg';

$self.getCPYFromRedis();
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
mounted() {
},
methods: {
...mapActions({
ACTION_setPageLoadingTrue: "common_ac_setPageLoadingTrue"
}),
...mapActions({
ACTION_setPageLoadingFalse: "common_ac_setPageLoadingFalse"
}),

getCPYFromRedis() {
var $self = this;
const params = {
dataMap: JSON.stringify({
data: $self.cpy,
businessType: 'pos',
type: '1'
})
};
$self.$webapi.redisInOut(params).then(redisRes => {
$self.$clog(redisRes.data);
if (redisRes.data.status == 1) {
$self.cpy = redisRes.data.result;









$self.subscribeUserInfo();
}
});
},














subscribeWx() {
var $self = this;
$self.$webapi.subscribeWx($self.merchant).then(res1 => {
$self.$clog("subscribeWx response");
$self.$clog(res1.data);

if (res1.data.status == 0) {
const redirectUrl = `${conf.api.LOCATION_ORIGIN}/xforce/#/orderInvoice/cfm?ut=${$self.token}&br=${$self.merchant}&cpy=${$self.cpy}`;
window.location.replace(redirectUrl);
} else if (res1.data.status == 1) {

$self.generateQrcode();
}
});
},

subscribeUserInfo() {
var $self = this;
const dataJ = {
code: $self.code,
state: $self.state
};
$self.$webapi.subscribeUserInfo(dataJ).then(res1 => {
$self.$clog("subscribeUserInfo response");
$self.$clog(res1.data);
if (res1.data.status == 1) {

$self.token = res1.data.token;

const redirectUrl = `${conf.api.LOCATION_ORIGIN}/xforce/#/orderInvoice/cfm?ut=${$self.token}&br=${$self.merchant}&cpy=${$self.cpy}`;
window.location.replace(redirectUrl);

} else if (res1.data.status == 0) {


$self.token = res1.data.token;
setToken($self.token);
$self.subscribeWx();
}
});
},

generateQrcode() {
var $self = this;
var dataJson = {
br: $self.merchant,
cpy: $self.cpy,
type: 'wx'
};

if($self.state && $self.state.indexOf('-') > -1){
dataJson.sub=$self.state.split('-')[1];
}
$self.ACTION_setPageLoadingTrue();
$self.$webapi.orderQrcode(dataJson).then(res2 => {
$self.ACTION_setPageLoadingFalse();
$self.$clog(res2.data);
if (res2.data.status == 1) {
$self.isShowQR = true;
$self.qrSrc = res2.data.url;
$self.qrMsg = '长按识别二维码关注公众号并开票';
} else if(res2.data.status == 302){
window.location.href = res2.data.redirectUrl
} else {
$self.qrMsg = res2.data.msg;
}
});
},
getRequest() {
var url = location.search;
url = url.replace('#/orderInvoice/followQrcode', '');
var theRequest = new Object();
if (url.indexOf('?') != -1) {
var str = url.split('?')[1];
var strs = str.split('&');
for (var i = 0; i < strs.length; i++) {
theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
}
}
return theRequest;
}
}
};
